import { computed, makeObservable } from 'mobx'

import { Collection } from 'modules/core/lib/mobx-rest'

import type { ICompensationChange } from 'modules/bookkeepers/store/models/CompensationChange'
import CompensationChange from 'modules/bookkeepers/store/models/CompensationChange'

class CompensationChanges extends Collection<CompensationChange> {
  constructor(data: ICompensationChange[] = []) {
    super(data)

    makeObservable(this, {
      byCompensation: computed,
    })
  }

  get cacheKey(): string {
    return 'compensationChanges'
  }

  get byCompensation() {
    return this.models.reduce((acc: Record<number, CompensationChange[]>, compensation) => {
      acc[compensation.originalCompensationId] = [
        ...(acc[compensation.originalCompensationId] || []),
        compensation,
      ]

      return acc
    }, {})
  }

  getHistoryForCompensation(compensationId: number) {
    return this.byCompensation[compensationId]
  }

  model() {
    return CompensationChange
  }
}

const singleton: CompensationChanges = new CompensationChanges()

export { CompensationChanges }

export default singleton
